import { ToDate } from '@app/utils/DateUtils';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useGoalCardViewCreator } from '@viewCreators/GoalCardViewCreator';

export const useGoalTrackerCardController = (cohortUserId: number, groupStart: string | DateTime) => {
  const { data: view, isLoading, refetch } = useGoalCardViewCreator(cohortUserId, groupStart);
  const [enabled, setEnabled] = useState(false);
  const [disabledMessage, setDisabledMessage] = useState<string>(
    "Don't worry! We won't start tracking goals until next week."
  );
  useEffect(() => {
    setDisabledMessage(
      `Don't worry! We won't start tracking goals until ${ToDate(groupStart).plus({ day: 7 }).toFormat('LLL dd')}.`
    );

    if (ToDate(groupStart) < DateTime.now()) {
      setEnabled(true);
    }
  }, [groupStart]);

  return { enabled, disabledMessage, view, isLoading, refetch };
};
